import { render, staticRenderFns } from "./NavbarDesktopTextBlocks.vue?vue&type=template&id=53e3d3b2&scoped=true&lang=pug&"
import script from "./NavbarDesktopTextBlocks.vue?vue&type=script&lang=js&"
export * from "./NavbarDesktopTextBlocks.vue?vue&type=script&lang=js&"
import style0 from "./NavbarDesktopTextBlocks.vue?vue&type=style&index=0&id=53e3d3b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e3d3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e3d3b2')) {
      api.createRecord('53e3d3b2', component.options)
    } else {
      api.reload('53e3d3b2', component.options)
    }
    module.hot.accept("./NavbarDesktopTextBlocks.vue?vue&type=template&id=53e3d3b2&scoped=true&lang=pug&", function () {
      api.rerender('53e3d3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/NavbarDesktopTextBlocks.vue"
export default component.exports